<template>
  <div class="page-container">
    <!-- Кривая линия -->
    <div class="curve-line" v-if="showCurve">
      <svg class="curve-svg" viewBox="0 0 100 1000" preserveAspectRatio="none">
        <path class="curve-path" d="M50,0 C70,50 30,150 50,200 C70,250 30,350 50,400 C70,450 30,550 50,600 C70,650 30,750 50,800 C70,850 30,950 50,1000" />
      </svg>
    </div>
    
    <main class="implants-page">
      <section class="silimed">
        <h2 class="section-title animate-element" ref="sectionTitle">{{ $t('stand.start')}}</h2>

        <div class="silimed-banner animate-element" ref="silimedBanner">
          <img src="/img/inplants1.jpg" alt="Silimed">
        </div>
      
        <div class="silimed-buttons animate-element" ref="silimedButtons">
          <a href="#" @click="goToBiodesin">{{ $t('stand.bio')}}</a>
          <a href="#" @click="goToStandard">{{ $t('stand.stand')}}</a>
          <a href="#" @click="goToType">{{ $t('stand.types')}}</a>
        </div>
      
        <div class="silimed-text animate-element" ref="silimedText">
          <h2>{{ $t('stand.title')}}</h2>
          <p>{{$t('stand.line')}}</p>
          <p>{{ $t('stand.milk')}}</p>
          <p>{{ $t('stand.linee')}}</p>
        </div>
      </section>

      <section id="models" aria-label="Модели и варианты">
        <div class="container">
          <h2 class="animate-element" ref="modelsTitle">{{ $t('stand.bioline')}}</h2>
          <div class="grid grid-5">
            <!-- Card 1 -->
            <div class="card model animate-element" ref="card1">
              <img class="model-img" src="/img/cart-select/max1.png" alt="" />
              <h3 class="card-title">MAXIMUM</h3>
              <div class="card-availability">
                <p class="label">{{ $t('stand.type')}}</p>
                <ul class="chips">
                  <li class="chip red"></li>
                </ul>
              </div>
            </div>

            <!-- Card 2 -->
            <div class="card model animate-element" ref="card2">
              <img class="model-img" src="/img/cart-select/max2-removebg-preview.jpg" alt="" />
              <h3 class="card-title">MAXIMUM</h3>
              <div class="card-availability">
                <p class="label">{{ $t('stand.type')}}</p>
                <ul class="chips">
                  <li class="chip blue"></li>
                </ul>
              </div>
            </div>

            <!-- Card 3 -->
            <div class="card model animate-element" ref="card3" style="padding: 0 20px 0 20px;">
              <img class="model-img soft" src="/img/Silimed-Soft-Plus-Surface-removebg-preview.jpg" alt="" style="height: 150px; width: 150px;">
              <h3 class="card-title soft">MAXIMUM</h3>
              <div class="card-availability">
                <p class="label">{{ $t('stand.type')}}</p>
                <ul class="chips">
                  <li class="chip green"></li>
                </ul>
              </div>
            </div>
          </div>
          
          <div class="cart-type-parag animate-element" ref="cartTypeParag">
            <p class="cart-type-p">{{ $t('stand.type')}}</p>
            <ul class="cart-type-ul">
              <li class="cart-type-li"><div class="red"></div> Pure Polyurethane</li>
              <li class="cart-type-li"><div class="blue"></div> True Texture</li>
              <li class="cart-type-li"><div class="green"></div>Soft Plus</li>
            </ul>
          </div>
        </div>
      </section>
        
      <section class="implants-page-end">
        <div class="page-end-img animate-element" ref="pageEndImg">
          <img src="/img/icon_main_1.jpg" alt="">
        </div>
        <div class="page-end-text">
          <h2 class="animate-element" ref="pageEndTitle">{{ $t('stand.gel')}}</h2>
          <ul class="animate-element" ref="pageEndList">
            <li>{{ $t('stand.silikon')}}</li>
            <li>{{ $t('stand.degree')}}</li>
            <li>{{ $t('stand.better')}}</li>
          </ul>
          <p class="animate-element" ref="pageEndParagraph"><sup style="font-size:.75em; line-height:0; vertical-align:super; margin-left:2px;">1</sup>{{ $t('stand.something')}}</p>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import { useRouter } from 'vue-router'

export default {
  name: 'StandardLineView',
  data() {
    return {
      showCurve: true,
      currentLang: 'ru',
      translations: {
        ru: {
          title: "Стандартная линия",
          description: "Описание стандартной линии",
          button: "Узнать больше"
        },
        uz: {
          title: "Standart chiziq",
          description: "Standart chiziq tavsifi",
          button: "Batafsil ma’lumot"
        }
      }
    }
  },
  setup() {
    const router = useRouter()

    function goToBiodesin() {
      router.push("/biodesain")
    }
    function goToStandard() {
      router.push("/standardline")
    }
    function goToType() {
      router.push("/type")
    }

    return { goToBiodesin , goToStandard , goToType }
  },
  mounted() {
    this.initAnimations();
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    this.translatePage(); // перевод сразу при загрузке
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    initAnimations() {
      if (this.showCurve) {
        setTimeout(() => {
          const curveLine = document.querySelector('.curve-line');
          if (curveLine) {
            curveLine.classList.add('animate-curve');
          }
        }, 100);
      }
      const isElementInViewport = (el) => {
        const rect = el.getBoundingClientRect();
        return (
          rect.top <= (window.innerHeight || document.documentElement.clientHeight) * 0.9 &&
          rect.bottom >= 0
        );
      };
      const handleScroll = () => {
        const elements = document.querySelectorAll('.animate-element');
        elements.forEach(element => {
          if (isElementInViewport(element)) {
            element.classList.add('animate');
          }
        });
      };
      window.addEventListener('load', handleScroll);
      window.addEventListener('scroll', handleScroll);
      handleScroll();
    },
    handleResize() {
      this.showCurve = window.innerWidth > 768;
    },
    // 🔥 функции для перевода
    setLanguage(lang) {
      this.currentLang = lang;
      this.translatePage();
    },
    translatePage() {
      const texts = document.querySelectorAll('[data-i18n]');
      texts.forEach(el => {
        const key = el.getAttribute('data-i18n');
        if (this.translations[this.currentLang][key]) {
          el.innerText = this.translations[this.currentLang][key];
        }
      });
    }
  }
}
</script>


<style scoped>
*{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

/* Контейнер для всей страницы с отступом */
.page-container {
  position: relative;
  max-width: 1200px;
  margin: 70px auto;
  padding: 0 20px;
}

.container {
  text-align: left;
  margin: 70px auto;
  max-width: 1200px;
  padding: 0 20px;
}

.silimed {
  text-align: center;
  margin: 70px auto;
  max-width: 1200px;
  padding: 0 20px;
}

.section-title{
  color: #505050;
  font-size: 36px;
  font-weight: 300;
  line-height: 48px;
  margin-bottom: 10px;
  margin-bottom: 100px;
}

.silimed-banner{
  margin-bottom: 30px;
  padding: 5px;
  border: 1px solid rgba(15, 131, 129, .14);
}


.silimed-buttons {
  margin: 30px 0;
  display: flex;
  justify-content: center;
  gap: 40px;
  height: 100px;
  width: 100%;
}

.silimed-buttons a {
  color: #108381;
  font-size: 16px;
  font-weight: 200;
  line-height: 76px;
  position: relative;
  width: calc(33.333% - 28px);
  margin: 15px 0;
  padding: 0 15px;
  transition: .2s linear;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  border: 1px solid #0f8381;
  background: #fff;
}

.silimed-buttons a:hover {
  background: teal;
  color: #fff;
}


.silimed-text {
  max-width: 1160px;
  margin: 0 auto;
  text-align: left;
}

.silimed-text h2 {
  color: #0d1016;
  font-size: 30px;
  font-weight: 100;
  line-height: normal;
  margin-bottom: 25px;
}

.silimed-text p {
  font-weight: 300;
  line-height: 30px;
  margin-bottom: 25px;
  color: #555;
  font-size: 18px;
}

.grid-5{
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 30px;
  justify-content: center;
}

.card{
  color: #ffffff;
  background: #1d8784;
  position: relative;
  margin: 35px 0 0 32px;
  padding: 28px;
  text-align: center;
  box-shadow: 0 0 49px rgba(151, 151, 151, .24);
  max-width: 350px;
  min-height: 280px;
}

.model-img{
  width: 166px;
  height: 110px;
  margin: auto;
  margin-bottom: 20px;
}

.soft {
  margin: auto;
  margin-bottom: 10px;
}


.card-title{
  color: #ffffff;
  font-weight: 500;
  transition: .2s linear;
  text-decoration: none;
  text-transform: uppercase;
  margin-bottom: 20px;
}

.card-subtitle{
  font-weight: 300;
  min-height: 20px;
  margin-bottom: 9px;
  font-size: 18px;
}

.card-bullets li {
  list-style: none;
}

.card-availability {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
}

.chips {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  list-style: none;
}

.red {
  color: #ff8400;
  background: #ff8400;
  width: 20px;
  height: 20px; 
  border-radius: 50%;
}

.blue {
  color: #007bff;
  background: #007bff;
  width: 20px;
  height: 20px;
  border-radius: 50%;
}

.green {
  color: #20cecb;
  background: #20cecb;
  width: 20px;
  height: 20px;
  border-radius: 50%;
}

.cart-type-parag {
  font-weight: 500;
  margin-bottom: 50px;
  padding: 12px 35px;
  background: #fafafa;
  align-items: center;
  margin-top: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.cart-type-ul {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 30px;
  list-style: none;
}

.cart-type-li{
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.visually-hidden-h2-sec {
    color: #343635;
    font-weight: 500;
    font-size: 18px;
    margin-bottom: 50px;
}

.implants-page-end {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 30px;
  text-align: left;
  margin: 70px auto;
  max-width: 1200px;
  padding: 0 20px;
}

.page-end-img img {
  height: 245px;
  width: 245px;
}

.page-end-text h2 {
  font-size: 22px;
  color: #f17015;
  margin: 0 0 15px;
  font-weight: 300;
}

.page-end-text ul {
  list-style: none;
  height: 105px;
  width: 100%;
  display: grid;
  row-gap: 5px;
}

.page-end-text ul li {
  color: #343635;
  font-weight: 300;
  font-size: 16px;
}

.page-end-text p {
  font-weight: 300;
  font-size: 13px;
  margin: 15px 0 0;
  line-height: 125%;
  color: #343635;
}

/* Анимационные стили */
.animate-element {
  transform: translateX(-100px);
  opacity: 0;
  transition: transform 0.8s ease-out, opacity 0.8s ease;
}

.animate {
  transform: translateX(0) !important;
  opacity: 1 !important;
}

/* Кривая линия - перемещена левее контента */
.curve-line {
  position: absolute;
  top: 0;
  left: -80px;
  width: 100px;
  height: 100%;
  z-index: -1;
}

.curve-svg {
  width: 100%;
  height: 100%;
}

.curve-path {
  fill: none;
  stroke: #0b8482;
  stroke-width: 2;
  stroke-dasharray: 1000;
  stroke-dashoffset: 1000;
  transition: stroke-dashoffset 2s ease-in-out;
}

.animate-curve .curve-path {
  stroke-dashoffset: 0;
}

/* Адаптация для мобильных устройств */
@media (max-width: 768px) {
  .page-container {
    padding: 0 15px;
    margin: 40px auto;
  }
  
  .curve-line {
    display: none; /* Скрываем линию на мобильных */
  }
  
  .animate-element {
    transform: translateX(-50px); /* Меньшее смещение для мобильных */
  }
  
  .silimed-buttons {
    flex-direction: column;
    height: auto;
    gap: 15px;
  }
  
  .silimed-buttons a {
    width: 100%;
    line-height: 50px;
  }
  
  .grid-5 {
    grid-template-columns: 1fr;
  }
  
  .card {
    max-width: 100%;
    margin: 20px 0;
  }
  
  .implants-page-end {
    flex-direction: column;
    text-align: center;
  }
  
  .cart-type-parag {
    flex-direction: column;
    gap: 15px;
  }
  
  .cart-type-ul {
    flex-direction: column;
    gap: 15px;
  }
}

/* 2K screens (>=1920px) */
@media (min-width: 1920px) {
  .container, .silimed, .implants-page-end { max-width: 1400px; }
  .section-title { font-size: 42px; line-height: 54px; }
  .silimed-text h2 { font-size: 34px; }
  .silimed-text p { font-size: 20px; line-height: 32px; }
  .card { max-width: 400px; min-height: 320px; }
  .page-end-img img { width: 300px; height: 300px; }
}

/* Large desktops (1440px–1919px) */
@media (min-width: 1440px) and (max-width: 1919px) {
  .container, .silimed, .implants-page-end { max-width: 1280px; }
  .section-title { font-size: 38px; }
}

/* Desktops / small laptops (1200px–1439px) */
@media (min-width: 1200px) and (max-width: 1439px) {
  .container, .silimed, .implants-page-end { max-width: 1140px; padding: 0 16px; }
  .grid-5 { gap: 24px; }
  .card { margin: 24px auto; }
}

/* Tablets landscape (1024px–1199px) */
@media (min-width: 1024px) and (max-width: 1199px) {
  .container, .silimed, .implants-page-end { max-width: 980px; padding: 0 16px; }
  .grid-5 { grid-template-columns: repeat(3, 1fr); gap: 20px; }
  .card { margin: 20px auto; }
  .page-end-img img { width: 220px; height: 220px; }
}

/* Tablets portrait (768px–1023px) */
@media (min-width: 768px) and (max-width: 1023px) {
  .container, .silimed, .implants-page-end { max-width: 740px; padding: 0 16px; }
  .section-title { font-size: 28px; line-height: 38px; margin-bottom: 60px; }
  .silimed-buttons { flex-wrap: wrap; height: auto; gap: 20px; }
  .silimed-buttons a { width: 100%; max-width: 260px; line-height: 50px; }
  .grid-5 { grid-template-columns: repeat(2, 1fr); gap: 20px; }
  .card { margin: 16px auto; max-width: 100%; }
  .implants-page-end { flex-direction: column; gap: 20px; text-align: center; }
  .page-end-img img { width: 200px; height: 200px; margin: 0 auto; }
  .page-end-text h2 { font-size: 20px; }
}

/* Large phones / small tablets (576px–767px) */
@media (min-width: 576px) and (max-width: 767px) {
  .container, .silimed, .implants-page-end { max-width: 540px; padding: 0 12px; }
  .section-title { font-size: 24px; line-height: 32px; margin-bottom: 40px; }
  .silimed-buttons { flex-direction: column; gap: 12px; height: auto; }
  .silimed-buttons a { width: 100%; max-width: 100%; line-height: 46px; font-size: 14px; }
  .grid-5 { grid-template-columns: 1fr; gap: 16px; }
  .card { margin: 12px auto; max-width: 100%; min-height: auto; padding: 20px; }
  .implants-page-end { flex-direction: column; gap: 16px; text-align: center; }
  .page-end-img img { width: 160px; height: 160px; margin: 0 auto; }
  .page-end-text ul { height: auto; row-gap: 8px; }
}

/* Phones (<=575px) */
@media (max-width: 575px) {
  .container, .silimed, .implants-page-end { padding: 0 10px; margin: 40px auto; }
  .section-title { font-size: 20px; line-height: 28px; margin-bottom: 24px; }
  .silimed-banner img { width: 100%; height: auto; }
  .silimed-buttons { flex-direction: column; gap: 10px; }
  .silimed-buttons a { font-size: 13px; line-height: 42px; padding: 0 10px; }
  .silimed-text h2 { font-size: 20px; margin-bottom: 16px; }
  .silimed-text p { font-size: 15px; line-height: 24px; margin-bottom: 16px; }
  .grid-5 { grid-template-columns: 1fr; gap: 14px; }
  .card { margin: 10px auto; padding: 16px; }
  .page-end-img img { width: 140px; height: 140px; }
  .page-end-text h2 { font-size: 18px; }
  .page-end-text ul li { font-size: 14px; }
  .page-end-text p { font-size: 12px; }
}

/* Tiny phones (<=380px) */
@media (max-width: 380px) {
  .section-title { font-size: 18px; line-height: 24px; }
  .silimed-text p { font-size: 14px; }
  .silimed-buttons a { font-size: 12px; line-height: 38px; }
  .page-end-img img { width: 120px; height: 120px; }
  .page-end-text h2 { font-size: 16px; }
}
</style>